import './HomePage.scss';

import Container from "../../components/Container"
import About from "../../components/Container/About"
import Home from "../../components/Container/Home"
import Projects from "../../components/Container/Projects"
import Contact from '../../components/Container/Contact';
import Skills from '../../components/Container/Skills';
import { useMotionValueEvent, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { usePublisher } from '../../helpers/functions/hooks/events';

const HomePage = (): JSX.Element => {
    const homeSection = useRef<HTMLElement>(null);
    const aboutMeSection = useRef<HTMLElement>(null);
    const skillsSection = useRef<HTMLElement>(null);
    const projectsSection = useRef<HTMLElement>(null);
    const contactSection = useRef<HTMLElement>(null);

    const homeScrollYProgress = useScroll({
        target: homeSection,
        offset: ["end end", "end start"]
    }).scrollYProgress;
    const aboutMeScrollYProgress = useScroll({
        target: aboutMeSection,
        offset: ["start start", "end start"]
    }).scrollYProgress;
    const skillsScrollYProgress = useScroll({
        target: skillsSection,
        offset: ["start start", "end start"]
    }).scrollYProgress;
    const projectsScrollYProgress = useScroll({
        target: projectsSection,
        offset: ["start start", "end end"]
    }).scrollYProgress;
    const contactScrollYProgress = useScroll({
        target: contactSection,
        offset: ["start end", "end end"]
    }).scrollYProgress;

    const scrollYProgress = useTransform(() => {
        return homeScrollYProgress.get()
         + aboutMeScrollYProgress.get()
         + skillsScrollYProgress.get() 
         + (projectsScrollYProgress.get() + contactScrollYProgress.get()) / 2
    });

    const publish = usePublisher();

    useMotionValueEvent(scrollYProgress, 'change', () => {
        publish('scrollProgressRef', scrollYProgress);
    });

    return (
        <div id="HomePage">
            <Container>
                <>
                    <Home homeSection={homeSection} />
                    <About aboutSection={aboutMeSection} />
                    <Skills skillsSection={skillsSection} />
                    <Projects projectsSection={projectsSection} />
                    <Contact contactSection={contactSection} />
                </>
            </Container>
        </div>
    );
}

export default HomePage;
